<template>
  <div>
    <v-row>
      <v-col>
        <upload-excel
          :on-success="handleSuccess"
          :before-upload="beforeUpload"
        />
      </v-col>
    </v-row>
    <v-row>
        <v-col>
            <v-btn color="primary" small @click="actualizarTarifas()">Actualizar Precios de Trámite de Importación</v-btn> -
            <v-btn color="info" small @click="limpiar()">Limpiar</v-btn>
        </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
        :items="tableData"
        :headers="headers"
        class="elevation-1"
        >reg
        </v-data-table>
      </v-col>
    </v-row>
    <v-row v-if="procesado">
      <v-col>
         <v-alert dense type="info">
          Tarifas Actualizadas
        </v-alert>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import UploadExcel from "../components/UploadExcel.vue";
import apicon from '../plugins/apicon';
export default {
  created: function () {},
  components: {
    UploadExcel,
  },
  data() {
    return {
      overlay: false,
      tableData: [],
      tableHeader: [],
      headers: [
        { text: "Categoria", value: "categoria" },
        { text: "Desde", value: "desde" },
        { text: "Hasta", value: "hasta" },
        { text: "Valor", value: "valor" },
      ],
      procesado: false,
      sheetName: null,
      isCliente: 1
    };
  },
  methods: {
    beforeUpload(file) {
      const isLt1M = file.size / 1024 / 1024 < 1;
      if (isLt1M) {
        return true;
      }
      this.$swal("No se pueden subir archivos mayortes a 1MB");
      return false;
    },
    handleSuccess({ results, header, sheetName }) {
      this.tableData = results;
      this.tableHeader = header;
      this.sheetName = sheetName;
      this.procesado = false;
    },
    limpiar: function(){
      this.tableData = [];
      this.tableHeader = [];
      this.procesado = false;
    },
    actualizarTarifas:async  function () {
      //Verificar si hay guias
      if(this.tableData.length == 0){
        this.$swal("No ha importado datos");
        return;
      }
      //verificar que se haya importado un archivo valido
      if(this.sheetName != 'precio_tramite'){
        this.$swal("El tipo de archivo importado parece no ser valido 'precio_tramite' - SheetName: " + this.sheetName);
        return;
      }

      //crear las piezas (solo una pieza)
      await apicon.saveDataApi(apicon.getApiBaseUrl() + 'actualizarpreciotramite',{precio_tramite : this.tableData}).then((result) =>{
              this.$swal(result.message);
      });

      this.tableData = [];
      this.procesado = true;
    },
  },
  mounted:async function () {
      await apicon.setAuthHeaders();
      this.isCliente = localStorage.getItem('cliente')
  },
};
</script>

<style>
</style>
